module.exports = __webpack_public_path__ + "static/media/expressjs-og.7ab82ced.svg";